export function triggerBrowserCsvDownload(
  csv: string,
  fileName = "download.csv",
) {
  const a = document.createElement("a");
  a.href = `data:text/csv;charset=utf-8,${csv}`;
  document.body.appendChild(a);
  a.download = fileName;
  a.click();
  document.body.removeChild(a);
}
